import { render } from "./KanangaLightfortheworld.vue?vue&type=template&id=134cf22f&scoped=true"
import script from "./KanangaLightfortheworld.vue?vue&type=script&lang=js"
export * from "./KanangaLightfortheworld.vue?vue&type=script&lang=js"

import "./KanangaLightfortheworld.vue?vue&type=style&index=0&id=134cf22f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134cf22f"]])

export default __exports__